export interface PreparationModel {
  finality?: string;
  amount?: number;
  installment?: number;
  duration?: number;
}
